import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const PracticalInformation = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4.5-12.5L14 14l-6.5 2.5L10 10l6.5-2.5ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
));
